import { useState } from 'react';
import moment  from 'moment'

export default function useToken() {

  const getToken = () => {
    const creationDate = sessionStorage.getItem('token_creation');
    if (creationDate != null) {
      const duration = moment.duration(moment().diff(creationDate));
      if(duration.asMinutes() > 59) {
        sessionStorage.clear();
        window.location.href = '/';
      }
    } 
    return (!sessionStorage.getItem('token')) ? null : sessionStorage.getItem('token');
  }

  const getRole = () => {
    return (!sessionStorage.getItem('role')) ? null : sessionStorage.getItem('role');
  }

  const getAbility = () => {
    return (!sessionStorage.getItem('abilities')) ? null : JSON.parse(sessionStorage.getItem('abilities'));
  }

  const getBusinessId = () => {
    return sessionStorage.getItem('business_id');
  }

  const [token, setToken] = useState(getToken());
  const [role, setRole] = useState(getRole());
  const [abilities, setAbilities] = useState(getAbility());

  const saveToken = token => {
    sessionStorage.setItem('token', token);
    setToken(token);
    sessionStorage.setItem('token_creation', moment());
  }

  const saveRole = role => {
    sessionStorage.setItem('role', role);
    setRole(role)
  }

  const saveAbilities = abilities => {
    sessionStorage.setItem('abilities', abilities);
    setAbilities(abilities);
  }

  const saveBusinessId = businessId => {
    sessionStorage.setItem('business_id', businessId);
  }

  return {
    setToken: saveToken,
    setRole: saveRole,
    setAbility: saveAbilities,
    setBusinessId: saveBusinessId,
    getToken: getToken,
    getBusinessId: getBusinessId,
    token,
    role,
    abilities
  }
}




 